/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Which page the resident sees, derived server-side from the sale, terms, lock and last look.
 * @export
 */
export const HomeownershipPageState = {
    Holding: 'holding',
    Interest: 'interest',
    Terms: 'terms',
    Accepted: 'accepted',
    Locked: 'locked',
    Declined: 'declined',
    Lapsed: 'lapsed',
    LastLook: 'last_look',
    Closed: 'closed'
} as const;
export type HomeownershipPageState = typeof HomeownershipPageState[keyof typeof HomeownershipPageState];


export function HomeownershipPageStateFromJSON(json: any): HomeownershipPageState {
    return HomeownershipPageStateFromJSONTyped(json, false);
}

export function HomeownershipPageStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipPageState {
    return json as HomeownershipPageState;
}

export function HomeownershipPageStateToJSON(value?: HomeownershipPageState | null): any {
    return value as any;
}

